"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomCharacterSelectMessage = void 0;
var common_1 = require("@timeflies/common");
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.RoomCharacterSelectMessage = message_1.createMessage('room/character/select', joi_1.default.object({
    aiPlayerId: common_1.playerIdSchema.allow(null),
    characterRole: common_1.characterRoleSchema
}))
    .withResponse();
